<!--
  CashMovementFormModal: ajuste positivo o negativo y transferencia entre cajas o cuentas.

  ENTRADA
    Props: no tiene.
    Métodos públicos (por ref):
      addAdjustment(type_balance, selectOrigin, cashId, cash)   type_balance: '+' o '-'.
      addTransfer(selectOrigin, cashId, cash)
        selectOrigin: true deja elegir la caja de origen y ignora cashId y cash.
        cashId, cash: caja de origen preseleccionada (id y objeto), con selectOrigin en false.
      close()   Cierra el modal sin confirmar.

  SALIDA
    Eventos:
      @saved(response)   Se guardó. La vista recarga lo que corresponda.
    Efectos:
      Guarda con agregarCajaDetalle. GENERA MOVIMIENTOS REALES DE CAJA: la transferencia crea salida y entrada.

  USOS
    Vista: <CashMovementFormModal ref="cashMovementForm" @saved="onCashMovementSaved" />
    Ajuste de la caja filtrada:  this.$refs.cashMovementForm.addAdjustment('+', false, cashId, cash)
    Ajuste eligiendo la caja:    this.$refs.cashMovementForm.addAdjustment('-', true)
    Transferencia:               this.$refs.cashMovementForm.addTransfer(false, cashId, cash)
    Hoy se invoca desde finances/staff/cashDetail.vue: menú de movimientos y ?new=1&mode= de la paleta de comandos.

  DEPENDENCIAS Y PERMISOS
    Tipos de movimiento bancario: los consulta por su cuenta con obtenerTiposMovimientoBancario() al montarse.
    Componentes: FindObject.
    No controla permisos: quien lo invoca decide si el usuario puede abrirlo.
-->
<template>
  <div>
    <!-- CRUD MAIN -->
    <b-modal v-model="modal.form.active"
            size="lg"
            :key="modal.form._id"
            :id="modal.form._id">                  
      <template #modal-header>
        <div class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon :name="crud.form.event == 'transfer' ? 'swap_horiz' : (crud.form.type_balance == '-' ? 'remove' : 'add')" /></span>
          <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
        </div>
      </template>

      <b-row>                     
        <b-col sm="12">
          <FindObject render="search"
                      type="cash"    
                      tag="Origen"                     
                      @select-object="loadCashOrigin($event)"
                      :valueID="crud.form.finances_cash_id"
                      :showAllRegister="true"
                      :where="conditionCash"
                      :disabled="!selectOriginForMovement"/>
        </b-col>

        <b-col sm="12" v-if="crud.form.event == 'transfer'">
          <FindObject render="search"
                      type="cash"                      
                      tag="Destino"                        
                      @select-object="loadCashTransfer($event)"                                                 
                      :valueID="crud.form.finances_cash_transfer_id"
                      :showAllRegister="true"
                      :key="keyForceUpdateCashTransfer"
                      :where="conditionCash"/>
        </b-col>          

        <b-col md="6">
          <b-form-group label="Fecha">
            <b-form-datepicker size="sm"  
                               v-model="crud.form.date" 
                               placeholder="Fecha" 
                               local="es">
            </b-form-datepicker>             
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Hora">
            <b-form-timepicker size="sm" 
                               v-model="crud.form.time"  
                               now-button 
                               reset-button 
                               locale="es">
            </b-form-timepicker>         
          </b-form-group>
        </b-col>
      
        <b-col md="12" v-if="crud.form.event == 'adjustment' && crud.form.finances_cash && crud.form.finances_cash.kind == 'BANK' && crud.form.finances_cash.allow_purchase_link">
          <b-form-group label="Tipo de movimiento bancario">
            <b-form-select size="sm" v-model="crud.form.bank_type">
              <b-form-select-option :value="null">Sin tipo</b-form-select-option>
              <b-form-select-option v-for="type in bankTypeOptions(crud.form.type_balance)" :key="type.value" :value="type.value">{{ type.text }}{{ type.purchase ? ' (lleva comprobante)' : '' }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="8">
          <div v-if="crud.form.event == 'adjustment'" class="cash-detail-modal-notice" :class="crud.form.type_balance == '-' ? 'cash-detail-modal-notice--negative' : 'cash-detail-modal-notice--positive'">
            <span class="cash-detail-modal-notice__icon"><AppIcon :name="crud.form.type_balance == '-' ? 'remove' : 'add'" /></span>
            <div><strong>{{ crud.form.type_balance == '-' ? 'Movimiento de egreso' : 'Movimiento de ingreso' }}</strong><span>El importe se registrará con saldo {{ crud.form.type_balance == '-' ? 'negativo' : 'positivo' }}.</span></div>
          </div>
          <div v-if="crud.form.event == 'transfer'" class="cash-detail-modal-notice cash-detail-modal-notice--transfer">
            <span class="cash-detail-modal-notice__icon"><AppIcon name="swap_horiz" /></span>
            <div><strong>Transferencia entre cajas</strong><span>Se genera una salida en origen y una entrada en destino.</span></div>
          </div>
        </b-col>
        <b-col md="4">
          <b-form-group label="Importe">
            <b-input-group prepend="$">            
              <app-number-input v-model="crud.form.amount" />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Referencia">
            <b-form-input type="text"
                          size="sm"
                          v-model="crud.form.reference"
                          required
                          placeholder="Ingresar una referencia">
            </b-form-input>
          </b-form-group>
        </b-col>          
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
        <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
      </div>
    </b-modal>      
  </div>
</template>
<script>
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject'

  export default {
    name: 'CashMovementFormModal',
    components: {
      FindObject,
    },
    data: () => {
      return {
        arr: {
          bankTypes: [],
        },
        crud: {
          form: {            
            finances_cash_id: 0,
            finances_cash: null,            
            bank_type: null,
            currency_id: 0,
            currency: null,
            date: '',
            time: '',
            reference: '',
            amount: 0,
            manual: true,
            event: 'adjustment'
          },                 
        },
        modal: {
          form: {
            active: false,
            title: ''
          },        
        },
        keyForceUpdateCashTransfer: 0,   
        selectOriginForMovement: false,
      }
    },
    computed: {
      conditionCash(){
        let condition = []
        condition.push({field: 'active', condition: true})
        return condition
      },       
    },
    mounted() {
      this.loadBankTypes()
    },
    methods: {
      // API PUBLICA PARA LA VISTA
      close() {
        this.modal.form.active = false
      },

      forceUpdateCashTransfer() {
        this.keyForceUpdateCashTransfer = this.keyForceUpdateCashTransfer + 1
      },                

      addAdjustment(type_balance, selectOrigin = false, cashId = 0, cash = null) {
        let title = "Ajuste Positivo"
        if(type_balance == '-') {
          title = "Ajuste Negativo"
        }

        this.crud.form.event = 'adjustment'       
        this.selectOriginForMovement = selectOrigin
        this.crud.form.finances_cash_id = selectOrigin ? 0 : cashId
        this.crud.form.finances_cash = selectOrigin ? null : cash
        this.crud.form.currency_id = 1
        this.crud.form.currency = null
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.time = ''
        this.crud.form.reference = ''
        this.crud.form.amount = 0
        this.crud.form.type_balance = type_balance
        this.crud.form.bank_type = null

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = title
        this.modal.form.active = true
      },   
      addTransfer(selectOrigin = false, cashId = 0, cash = null) {
        this.crud.form.event = 'transfer'       
        this.crud.form.bank_type = null
        this.selectOriginForMovement = selectOrigin
        this.crud.form.finances_cash_id = selectOrigin ? 0 : cashId
        this.crud.form.finances_cash = selectOrigin ? null : cash
        this.crud.form.finances_cash_transfer_id = 0
        this.crud.form.finances_cash_transfer = null        
        this.crud.form.currency_id = 1
        this.crud.form.currency = null
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.time = ''
        this.crud.form.reference = ''
        this.crud.form.amount = 0         
        this.crud.form.type_balance = "-"

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Transferencia"
        this.modal.form.active = true
      },   

      loadCashTransfer (object) {        
        if(object){          
          this.crud.form.finances_cash_transfer = object
          this.crud.form.finances_cash_transfer_id = object.id    

          if(this.crud.form.finances_cash_transfer_id == this.crud.form.finances_cash_id) {
            this.crud.form.finances_cash_transfer = null
            this.crud.form.finances_cash_transfer_id = 0
            this.forceUpdateCashTransfer()

            this.$awn.info("La caja/cuenta origen debe ser distina a la de destino");
            return false
          } 
        } else {
          this.crud.form.finances_cash_transfer = null
          this.crud.form.finances_cash_transfer_id = 0
        }
      },
      loadCashOrigin(object) {
        this.crud.form.finances_cash = object || null
        this.crud.form.finances_cash_id = object ? object.id : 0

        if (this.crud.form.finances_cash_transfer_id == this.crud.form.finances_cash_id) {
          this.crud.form.finances_cash_transfer = null
          this.crud.form.finances_cash_transfer_id = 0
          this.forceUpdateCashTransfer()
        }
      },

      save() {
        if(!this.crud.form.finances_cash_id) {
          this.$awn.warning("Seleccioná la caja/cuenta de origen")
          return false
        }

        if(this.crud.form.event == 'transfer' && !this.crud.form.finances_cash_transfer_id) {
          this.$awn.warning("Seleccioná la caja/cuenta de destino")
          return false
        }
        if(!this.crud.form.reference) {
          this.$awn.warning("Ingresá una referencia");
          return false
        }

        if(parseFloat(this.crud.form.amount)<0) {
          this.$awn.warning("Ingresá una importe mayor a cero (0)");
          return false
        }        

        let loader = this.$loading.show();

        var result = serviceAPI.agregarCajaDetalle(this.crud.form);
        
        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.$emit('saved', response)

          this.$awn.success("Ajuste guardado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      // TIPOS DE MOVIMIENTO BANCARIO (catálogo: FinancesCashDetail::BANK_TYPES)
      loadBankTypes() {
        serviceAPI.obtenerTiposMovimientoBancario().then((response) => {
          this.arr.bankTypes = response.data
        })
      },
      bankTypeOptions(typeBalance) {
        return this.arr.bankTypes.filter(element => !element.balance || element.balance == typeBalance)
      },
    }
  }
</script>
<style scoped>
  .cash-detail-modal-notice { align-items: center; border: 1px solid; border-radius: 8px; display: flex; gap: 10px; min-height: 72px; padding: 12px; }
  .cash-detail-modal-notice__icon { align-items: center; border-radius: 50%; display: inline-flex; flex: 0 0 32px; height: 32px; justify-content: center; }
  .cash-detail-modal-notice__icon .material-symbols-rounded { font-size: 19px; }
  .cash-detail-modal-notice strong { color: var(--app-color-text); font-size: var(--app-text-sm); margin-bottom: 2px; }
  .cash-detail-modal-notice div > span { color: var(--app-color-text-secondary); display: block; font-size: var(--app-text-sm); }
  .cash-detail-modal-notice--positive { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); }
  .cash-detail-modal-notice--positive .cash-detail-modal-notice__icon { background: var(--app-color-surface); color: var(--app-color-success); }
  .cash-detail-modal-notice--negative { background: var(--app-color-danger-soft); border-color: var(--app-color-danger-border); }
  .cash-detail-modal-notice--negative .cash-detail-modal-notice__icon { background: var(--app-color-surface); color: var(--app-color-danger); }
  .cash-detail-modal-notice--transfer { background: var(--app-color-info-soft); border-color: var(--app-color-info-border); }
  .cash-detail-modal-notice--transfer .cash-detail-modal-notice__icon { background: var(--app-color-surface); color: var(--app-color-info); }
</style>
